import React from "react";
import { withStyles } from "@material-ui/core/styles";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import moment from "moment";

import { REMOTEHOST } from "../config";

const startOfDay = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
};

const formatDate = date => {
  return moment(date).format("YYYY-MM-DDTHH:mm");
};

const transformDate = date => {
  return date && date.toISOString === "function" ? date.toISOString() : date;
};

class LogDownloadActions extends React.Component {
  state = {
    startDate: startOfDay(),
    endDate: new Date(),
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render() {
    const { classes, kiosk } = this.props;
    const { startDate, endDate } = this.state;

    return (
      <div>
        <TextField
          id="datetime-local"
          label="Du"
          type="datetime-local"
          value={formatDate(startDate)}
          onChange={this.handleChange("startDate")}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <br />
        <TextField
          id="datetime-local"
          label="Au"
          type="datetime-local"
          value={formatDate(endDate)}
          onChange={this.handleChange("endDate")}
          className={classes.textField}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <br />
        <br />
        <Button
          id="download"
          className={classes.button}
          label="label"
          color="secondary"
          disabled={kiosk.status > 3}
          download
          href={`${REMOTEHOST}/logfile/${
            kiosk.serialno
          }?startDate=${transformDate(startDate)}&endDate=${transformDate(
            endDate
          )}`}
        >
          Télécharger les tickets de vente
        </Button>
      </div>
    );
  }
}

const styles = theme => ({
  button: {
    marginBottom: theme.spacing.unit * 2,
    padding: 0,
  },
});

LogDownloadActions.defaultProps = { addLabel: true };

export default withStyles(styles)(LogDownloadActions);



// WEBPACK FOOTER //
// ./src/components/logDownloadActions.js